module.exports = __webpack_public_path__ + "bb15358d3a72ffa378df61b7d383de89.jpg";